import { defineMessages } from 'react-intl';

export default defineMessages({
  title: 'New version available!',
  content: 'If you have unsaved work you can close this dialog and save you work, before refreshing the browser.',
  button: 'Update',
});
